import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import {
  showStatus,
  encodeValue,
  removeItem,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      clientList: [],
      loading: true,
      name: "",
      email: "",
      contactnumber: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.clientList !== this.state.clientList) {
      this.setState({
        clientList: nextProps.clientList,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };

  removeItem(CompnayId) {
    removeItem(CompnayId, 'company/', 'master', this.sateValChange, 'client', 1);
  }

  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.email !== "") {
      addParams += "&email=" + this.state.email;
    }
    if (this.state.contactnumber !== "") {
      addParams += "&contactnumber=" + this.state.contactnumber;
    }
    if (Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params: `limit=${adminlimit}&offset=${offset}${addParams}`,
      url: apiUrl + "company",
      type: "master",
    };

    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props}  currentPage={"client"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">Company</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/masterpanel/client/add"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Add New
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={this.handleChangeText}
                        value={this.state.name}
                      />
                      <label htmlFor="outlet_pos_id">Name</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        onChange={this.handleChangeText}
                        value={this.state.email}
                      />
                      <label htmlFor="outlet_pos_id">Email</label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="contactnumber"
                        onChange={this.handleChangeText}
                        value={this.state.contactnumber}
                      />
                      <label htmlFor="outlet_pos_id">Contact Number</label>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline custm-select-box filter-select">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "In-Active" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>

                  <div className="col-md-1 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                  </div>
                  <div className="col-md-1 mt-2">
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  {/* table-responsive text-nowrap  */}
                  <div className="p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Client Name</th>
                          <th>User Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Web Site</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.clientList.length > 0 ? (
                          this.state.clientList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <strong>{item.companyName}</strong>
                                </td>
                                <td>{item.companyUsername}</td>
                                <td>
                                  <a
                                    href={
                                      "mailto:" + item.companyEmail
                                    }
                                  >
                                    {item.companyEmail}
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href={"tel:" + item.companyContactNumber}
                                  >
                                    {item.companyContactNumber}
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href={item.companyWebSite}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {item.companyWebSite}
                                  </a>
                                </td>
                                <td>{showStatus(item.companyStatus)}</td>
                                <td>
                                  <div className="dropdown">
                                    <button
                                      type="button"
                                      className="btn p-0 dropdown-toggle hide-arrow"
                                      data-bs-toggle="dropdown"
                                    >
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link
                                        to={
                                          "/masterpanel/client/edit/" +
                                          encodeValue(item._id)
                                        }
                                        className="dropdown-item"
                                      >
                                        <i className="mdi mdi-pencil-outline me-1"></i>
                                        Edit
                                      </Link>
                                      <a
                                        className="dropdown-item"
                                        href={() => false}
                                        onClick={this.removeItem.bind(
                                          this,
                                          encodeValue(item._id)
                                        )}
                                      >
                                        <i className="mdi mdi-trash-can-outline me-1"></i>
                                        Delete
                                      </a>
                                      <a
                                        className="dropdown-item"
                                        href={"/clientpanel/login"}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <i className="mdi mdi-arrow-right-bold"></i>
                                        Client Panel
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No Company Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var clientList = [];
  var clientListStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    clientListStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      clientList = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    clientList: clientList,
    totalPages: totalPages,
    totalRecords: totalRecords,
    clientListStatus: clientListStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
